
<template></template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@/api.js";

export default {
  data() {
    return {
      matchId: null,
      matchType: null,
      matchEventType: null,
      refundRecoverId: null
    };
  },
  mounted() {
    // this.actionFindNow(this);
  },
  computed: {
    ...mapGetters(["getLinkHandling"]),
    ...mapGetters("message", ["getMessage"])
  },
  methods: {
    ...mapActions("message", ["actionSetMessage", "actionConfirmMessage"]),
    ...mapActions("filters", [
      "actionSetFilterMode",
      "actionFindNow",
      "actionSetIsClearFilter"
    ]),
    unmatchLink(val) {
      if (val.type == "unmatchLinkPVR") {
        this.matchType = "PVR";
      } else if (val.type == "unmatchLinkRVB") {
        this.matchType = "RVB";
      }

      if (this.matchType == null) {
        return;
      }
      this.matchId = val.id;
      this.matchEventType = val.eventType;
      this.actionConfirmMessage("Are you sure to unlink the matched records?")
        .then(res => {
          api.request(
            this,
            "post",
            "/CCRS/unlinkMatch",
            {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              Parameters: {
                match_id: this.matchId,
                matchType: this.matchType,
                matchEventType: this.matchEventType,
                user_id: JSON.parse(window.localStorage.getItem("ccrs_user"))
                  .session_id
              }
            },
            function(r) {
              this.actionFindNow(this);
              // this.actionSetMessage({
              //   code: 2,
              //   message: "unMatch Success"
              // });
            },
            function(r) {},
            false,
            null
          );
        })
        .catch(e => {});
    },

    approveReconRefundRecover(val) {
      this.refundRecoverId = val.id;

      this.actionConfirmMessage("Are you sure to approve the records?")
        .then(res => {
          api.request(
            this,
            "post",
            "/CCRS/report03_approve",
            {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              Parameters: {
                ID: this.refundRecoverId
              }
            },
            function(r) {
              this.actionFindNow(this);
              // this.actionSetMessage({
              //   code: 2,
              //   message: "unMatch Success"
              // });
            },
            function(r) {},
            false,
            null
          );
        })
        .catch(e => {});
    },

    removeReconRefundRecover(val) {
      this.refundRecoverId = val.id;
      this.actionConfirmMessage("Are you sure to remove the records?")
        .then(res => {
          api.request(
            this,
            "post",
            "/CCRS/report03_remove",
            {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              Parameters: {
                ID: this.refundRecoverId
              }
            },
            function(r) {
              this.actionFindNow(this);
              // this.actionSetMessage({
              //   code: 2,
              //   message: "unMatch Success"
              // });
            },
            function(r) {},
            false,
            null
          );
        })
        .catch(e => {});
    },

    jelink(val) {
      api.request(
        this,
        "post",
        "/CCRS/ExportJE",
        {
          SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
            .session_id,
          Parameters: {
            ID: val.id
          }
        },
        function(r) {
          // this.actionFindNow(this);
          // this.actionSetMessage({
          //   code: 2,
          //   message: "unMatch Success"
          // });
        },
        function(r) {},
        false,
        "blob"
      );
    },

    approveHandleOffline(val){
         this.actionConfirmMessage("Are you sure to approve the records?")
        .then(res => {
          api.request(
            this,
            "post",
            "/CCRS/approveOffline",
            {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              Parameters: {
                ID: val.id
              }
            },
            function(r) {
              this.actionFindNow(this);
              // this.actionSetMessage({
              //   code: 2,
              //   message: "unMatch Success"
              // });
            },
            function(r) {},
            false,
            null
          );
        })
        .catch(e => {});
    
    },
    removeHandleOffline(val){
       this.actionConfirmMessage("Are you sure to remove the records?")
        .then(res => {
          api.request(
            this,
            "post",
            "/CCRS/removeOffline",
            {
              SessionID: JSON.parse(window.localStorage.getItem("ccrs_user"))
                .session_id,
              Parameters: {
                ID: val.id
              }
            },
            function(r) {
              this.actionFindNow(this);
              // this.actionSetMessage({
              //   code: 2,
              //   message: "unMatch Success"
              // });
            },
            function(r) {},
            false,
            null
          );
        })
        .catch(e => {});
    }
  },
  watch: {
    getLinkHandling: {
      handler(val) {
        if (!val) return;

        console.log(val);

        if (val.type.includes("unmatchLink")) {
          this.unmatchLink(val);
        } else if (val.type.includes("approveReconRefundRecover")) {
          this.approveReconRefundRecover(val);
        } else if (val.type.includes("removeReconRefundRecover")) {
          this.removeReconRefundRecover(val);
        } else if (val.type.includes("JELINK")) {
          this.jelink(val);
        } else if(val.type.includes("approveHandleOffline")){
          this.approveHandleOffline(val)
        }else if(val.type.includes("removeHandleOffline")){
          this.removeHandleOffline(val)
        }
      },
      deep: true
    }
  }
};
</script>

<style>
</style>